import React from 'react';
import {
  IoCheckmarkCircle,
  IoCloseCircle,
  IoWarning,
  IoInformationCircle,
  IoClose,
} from 'react-icons/io5';

const variantConfig = {
  success: {
    accent: 'bg-emerald-500',
    iconBg: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
    Icon: IoCheckmarkCircle,
  },
  error: {
    accent: 'bg-red-500',
    iconBg: 'bg-red-50',
    iconColor: 'text-red-600',
    Icon: IoCloseCircle,
  },
  warning: {
    accent: 'bg-amber-500',
    iconBg: 'bg-amber-50',
    iconColor: 'text-amber-600',
    Icon: IoWarning,
  },
  info: {
    accent: 'bg-blue-500',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-600',
    Icon: IoInformationCircle,
  },
};

/**
 * Reusable custom toast UI built on react-toastify.
 * White card, large rounded corners, soft border, subtle shadow,
 * left vertical accent strip, circular icon, message, close button.
 */
const CustomToast = ({ closeToast, data }) => {
  const message = data?.message ?? '';
  const type = data?.type ?? 'info';
  const config = variantConfig[type] ?? variantConfig.info;
  const { accent, iconBg, iconColor, Icon } = config;

  const accentGradient =
    type === 'success'
      ? 'linear-gradient(90deg, #22c55e, #16a34a)'
      : type === 'error'
        ? 'linear-gradient(90deg, #ef4444, #dc2626)'
        : null;

  return (
    <div className="flex items-center min-h-0 w-full rounded-2xl border border-gray-200/90 bg-white shadow-md overflow-hidden">
      {/* Left vertical accent strip */}
      <div
        className={`w-1 flex-shrink-0 self-stretch ${accent}`}
        style={accentGradient ? { backgroundImage: accentGradient } : undefined}
        aria-hidden
      />

      <div className="flex items-center gap-3 flex-1 min-w-0 py-3 pl-3 pr-2">
        {/* Circular icon container */}
        <div
          className={`flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center ${iconBg}`}
          aria-hidden
        >
          <Icon className={`w-5 h-5 ${iconColor}`} />
        </div>

        {/* Message text centered vertically */}
        <p className="flex-1 text-sm text-gray-800 leading-snug py-0.5 min-w-0">
          {message}
        </p>

        {/* Close button */}
        <button
          type="button"
          onClick={closeToast}
          className="flex-shrink-0 p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-1"
          aria-label="Close"
        >
          <IoClose className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default CustomToast;
